import React from 'react';
import { Link } from 'react-router-dom';
import { Briefcase, FileText, Search, DollarSign, ArrowRight, Sparkles } from 'lucide-react';
import { FinalCta } from './ForArtists';

const PERKS = [
  { Icon: Search,    color: '#22d3ee', title: 'Browse working indie catalogs', desc: 'Search by genre, mood, BPM, lyrical theme. Audition tracks before you license.' },
  { Icon: FileText,  color: '#ffcf52', title: 'Instant license generation',     desc: 'Single Stripe payment generates your PDF + Content ID whitelist. Drop it in your edit and ship.' },
  { Icon: DollarSign,color: '#34d399', title: 'Non-exclusive, fair, fast',      desc: 'Artist-set tier pricing. Pay once for ad / web / TV scope. No hidden middlemen.' },
  { Icon: Briefcase, color: '#a78bfa', title: 'Bulk licenses + team seats',     desc: 'Agency tier with shared invoicing, team accounts, and quarterly retainer pricing.' },
];

export default function ForAgencies() {
  return (
    <div className="max-w-[1100px] mx-auto" data-testid="landing-agencies">
      <header className="py-10 md:py-16">
        <div className="chip"><Briefcase className="w-3 h-3" /> For marketing agencies</div>
        <h1 className="font-display text-[40px] sm:text-[56px] md:text-[72px] leading-[0.95] mt-4 max-w-[960px]">
          Real indie music. <span className="text-[#a78bfa]">Real licenses.</span> No blanket subs.
        </h1>
        <p className="text-white/70 text-[16px] md:text-[18px] mt-5 max-w-[680px] leading-relaxed">
          Coming Q3 2026: a licensing marketplace where you pay artists fairly and ship faster. Get on the early-access list — we&apos;re onboarding 10 launch agencies.
        </p>
      </header>

      <section className="grid sm:grid-cols-2 gap-3 mb-7">
        {PERKS.map(p => (
          <div key={p.title} className="card-shell p-5 hover-lift">
            <div className="w-10 h-10 rounded-xl grid place-items-center" style={{ background: p.color + '22', color: p.color }}><p.Icon className="w-5 h-5" /></div>
            <h3 className="font-display text-[16px] mt-3">{p.title}</h3>
            <p className="text-[12.5px] text-white/60 mt-1.5 leading-relaxed">{p.desc}</p>
          </div>
        ))}
      </section>

      <section className="card-shell p-6 md:p-8 mb-12 text-center" style={{ background: 'linear-gradient(135deg, rgba(167,139,250,0.18), rgba(34,211,238,0.12))', borderColor: 'rgba(167,139,250,0.45)' }}>
        <Sparkles className="w-7 h-7 mx-auto text-[#a78bfa]" />
        <h2 className="font-display text-[28px] md:text-[36px] mt-3">Get on the early-access list</h2>
        <p className="text-white/65 text-[13.5px] mt-2 max-w-[520px] mx-auto">10 agencies will get full access before public launch + a 6-month commission waiver on their first $25K of licensing GMV.</p>
        <Link to="/beta?feature=licensing-marketplace" className="btn-primary mt-5 inline-flex" data-testid="landing-cta">
          Apply for early access <ArrowRight className="w-4 h-4" />
        </Link>
      </section>
    </div>
  );
}
